import { Component, OnInit } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { GeneralService } from '../services/general.service';

@Component({
  selector: 'app-equipe-travail',
  templateUrl: './equipe-travail.component.html',
  styleUrls: ['./equipe-travail.component.scss']
})
export class EquipeTravailComponent implements OnInit {

  constructor(public  generaleService : GeneralService) { }
  listeLanges = [];
  listeImages = [];
  EmpFr;
  EmpEn;
  facebook;
  instagram;
  tweeter;
  mode : string;
  selectedImage;
  mainImage;
  editorConfig2: AngularEditorConfig = JSON.parse(JSON.stringify(this.generaleService.editorConfig)) ;
  compte : number;
  ngOnInit() 
  {
    this.mainImage = {File_Content : "assets/icon.png"}
    this.getListeImage();
  }
  getLg()
  {
    this.generaleService.rechercheTable("recherche/tbdata?tablere=lgweb").subscribe(data =>
    {
      this.listeLanges = data;
    })
  }
  getListeImage()
  {
    this.listeImages = [];
    this.generaleService.rechercheTable(this.generaleService.url+ "avtFilesType&param=TEAM").subscribe( img =>
    {
      this.listeImages = img;
      this.getImageContent()
      this.getLg();
    });
  }
  getImageContent()
  {
    var compte = this.listeImages.length;
    for(let i=0;i< this.listeImages.length;i++)
    {
      this.generaleService.rechercheTable(this.generaleService.urlFiles+"&val="+ this.listeImages[i].File_Id).subscribe( file =>
      {
        this.listeImages[i].File_Content =file.Files[0].File_Content;
        compte--
        if(compte == 0)
          this.generaleService.disabled = false;
      });
    }
  }
  openFrmImage(mode,image?)
  {
    document.getElementById('input_file').click();
    this.mode = mode;
    if(image)
      this.selectedImage = image;
  }
  ajouter()
  {
    if(this.EmpFr && this.EmpEn)
    {
      this.compte = 3;
      this.generaleService.disabled = true;
      var File_Lien= (this.facebook ? this.facebook : "") +";" + (this.instagram ? this.instagram : "") +";" + (this.tweeter ? this.tweeter : "")
      var File_Key = (new Date()).getTime().toString();
      this.addFiles(this.mainImage.File_Content,"",File_Key,"TEAM","","","",File_Lien);
      this.enregistrerLanguage(File_Key,0,this.EmpEn);
      this.enregistrerLanguage(File_Key,1,this.EmpFr);
    }
  }
  enregistrerLanguage(Lg_Code,Lg_Langue,Lg_Libelle)
  {
    this.generaleService.dsLanguage.Lg[0].Lg_Code = Lg_Code;
    this.generaleService.dsLanguage.Lg[0].Lg_Langue = Lg_Langue;
    this.generaleService.dsLanguage.Lg[0].Lg_Libelle = Lg_Libelle;
    this.generaleService.dsLanguage.Lg[0].Lg_Source = "WEB";
    this.generaleService.enregisterTable(this.generaleService.dsLanguage).subscribe(data =>
    {
      this.generaleService.dialogSuccess("Enregistrer",true);
      this.generaleService.disabled = false;
      this.compte--;
      if(this.compte == 0)
      {
        this.getListeImage();
      }
    },()=>
    {
      this.generaleService.dialogSuccess("Non enregistrer",false);
      this.generaleService.disabled = false;
    })
  }
  onChangeImagefile(fileInput)
  {   
    var current_file = fileInput.target.files[0];
    var reader = new FileReader();
    if (current_file.type.indexOf('image') == 0) 
    {
      reader.onload =  (e) =>
      {
        if(this.mode == "ajouter")
        {
          this.mainImage.File_Content = reader.result.toString();
        }
        else if(this.mode == "modifier")
        {
          this.generaleService.disabled = true;
          this.modifierImage(reader.result.toString(),this.selectedImage.File_Id);
        }
      }
      reader.readAsDataURL(current_file);
    }
    else
      this.generaleService.dialogSuccess("Veuillez sélectionner une image",false)
  }
  modifierImage(File_Content,File_Id,File_Lien?)
  {
    this.generaleService.rechercheTable(this.generaleService.urlFiles+"&val="+File_Id.toString()).subscribe(data =>
    {
      data.Files[0].File_Content = File_Content;
      if(File_Lien)
      data.Files[0].File_Lien = File_Lien;
      this.generaleService.enregisterTable(data).subscribe(data =>
      {
        this.generaleService.disabled = false;
        this.generaleService.dialogSuccess("Enregistrer",true)
      })
    })
  }
  addFiles(File_Content,File_Text,File_Key,File_Type,File_Parent,clickMode,File_Groupe,File_Lien)
  {
    var doc = this.generaleService.dsFile;
    doc.files[0].File_Parent =File_Parent;
    doc.files[0].File_Content = File_Content;
    doc.files[0].File_Text = File_Text;
    doc.files[0].File_Key = File_Key;
    doc.files[0].File_Type = File_Type;
    doc.files[0].File_Groupe = File_Groupe;
    doc.files[0].File_Lien = File_Lien;
    
    this.generaleService.enregisterTable(doc).subscribe(()=>
    {
      this.compte--;
      if(this.compte == 0)
      {
        this.getListeImage();
      }
      this.generaleService.dialogSuccess("Document enregisté",true);
      this.generaleService.disabled = false;
      this.getListeImage();
    })
  }
  findLangue(Lg_Code,Lg_Langue)
  {
    return this.listeLanges.find(lg => {return lg.Lg_Code == Lg_Code && lg.Lg_Langue.toString() == Lg_Langue});
  }
  selectImage(image)
  {
    this.mainImage  = image;
    var EmpFr,EmpEn ;
    EmpFr =  this.findLangue( image.File_Key ,"0");
    if(EmpFr)
      this.EmpFr= EmpFr.Lg_Libelle;
    EmpEn = this.findLangue( image.File_Key ,"1");
    if(EmpEn)
    this.EmpEn= EmpEn.Lg_Libelle;
    var tab = image.File_Lien.split(";")
    if(tab && tab.length ==3)
    {
      this.facebook = tab[0];
      this.instagram = tab[1];
      this.tweeter = tab[2];
    }
    else
    {
      this.facebook = "";
      this.instagram = "";
      this.tweeter = "";
    }
  }
  modifier()
  {
    this.compte = 3;
    var EmpFr,EmpEn ;
    var File_Lien= (this.facebook ? this.facebook : "") +";" + (this.instagram ? this.instagram : "") +";" + (this.tweeter ? this.tweeter : "")
    this.modifierImage(this.mainImage.File_Content,this.mainImage.File_Id,File_Lien)
    EmpFr =  this.findLangue( this.mainImage.File_Key ,"0");
    if(EmpFr)
    this.modifierLanguage(EmpFr.Lg_Id,this.EmpFr)
    EmpEn = this.findLangue( this.mainImage.File_Key ,"1");
    if(EmpEn)
    this.modifierLanguage(EmpEn.Lg_Id,this.EmpEn)
  }
  modifierLanguage(Lg_Id,Lg_Libelle )
  {
    this.generaleService.rechercheTable("ds/formdata?code=Lg&val=" + Lg_Id).subscribe(data =>
    {
      data.Lg[0].Lg_Libelle = Lg_Libelle;
      data.Lg[0].Lg_Source = "WEB";
      this.generaleService.enregisterTable(data).subscribe(()=>
      {
        this.compte--;
        if(this.compte == 0)
            this.getLg();
        this.generaleService.dialogSuccess("Enregistrer",true);
      },()=>{this.compte--;this.generaleService.dialogSuccess("Non enregistrer",false)})
      
    },()=>{this.compte--;this.generaleService.dialogSuccess("Non enregistrer",false)})
  }
  supprimer()
  {
    var deleteFn = this.generaleService.supprimer(this.mainImage.File_Id,"avtFiles");
    if(deleteFn != null)
    {      
      this.generaleService.disabled = true;
      deleteFn.subscribe(data => {this.generaleService.dialogSuccess("Supprimer",true);this.getListeImage();});
      var EmpFr,EmpEn ;
      EmpFr =  this.findLangue( this.mainImage.File_Key ,"0");
      if(EmpFr)
        this.generaleService.supprimerSanMsgConfirm(EmpFr.Lg_Id ,"lg").subscribe(data => {});
      EmpEn = this.findLangue( this.mainImage.File_Key ,"1");
      if(EmpEn)
        this.generaleService.supprimerSanMsgConfirm(EmpEn.Lg_Id ,"lg").subscribe(data => {});
    }
  }
}
